import React from "react";
import t from "i18n";

const FrequencyFilter = ({ frequency, updateFrequency, fetching }) => {
  return (
    <div className={"event-registrant-frequency-container"}>
      <div
        className={"event-registrant-frequency-option " + (frequency == "DAILY" ? 'selected' : '')}
        onClick={() => !fetching && updateFrequency('DAILY')}
      >
        {t('DAILY')}
      </div>
      <div
        className={"event-registrant-frequency-option " + (frequency == "MONTHLY" ? 'selected' : '')}
        onClick={() => !fetching && updateFrequency('MONTHLY')}
      >
        {t('MONTHLY')}
      </div>
      <div
        className={"event-registrant-frequency-option " + (frequency == "YEARLY" ? 'selected' : '')}
        onClick={() => !fetching && updateFrequency('YEARLY')}
      >
        {t('YEARLY')}
      </div>
    </div>
  );
};

export default FrequencyFilter;



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/EventRegistrantLinechart/FrequencyFilter.js